import React from "react";
import "./Checkbox.css";

export default function Checkbox({ checked, onChange }) {
    return (
        <label className="custom-checkbox-container">
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className="custom-checkbox"
            />
            <span className="custom-checkbox-ui"></span>
        </label>
    );
}